import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListIds, getListFromValues, hasChangedValues, getFormValue, getListItems, getMergedValues, changeItemsValue, nullDate } from '../../public/utility'
class SelectDateDiv extends React.Component {

    // constructor() {
    //     super()
    //     window.form = this
    // }
    state = {}

    handelExportMealOrderRecord = () => {
        const { onClose, onSave } = this.props
        const { changedValues基本信息 } = this.state

        Tyan.pubForm.showExport({ event: 'ExportMealOrderRecord', eventData: { 订餐月份: getFormValue(this, '基本信息', '订餐月份') }, title: '导出月薪明细' })
        onClose && onClose()
        // Tyan.doPostEvent({
        //     event: 'ExportMealOrderRecord',
        //     data: {
        //         id, changedValues基本信息
        //     },
        //     onEnd: ({ errorMessage }) => {
        //         if (errorMessage) {
        //             Tyan.pubForm.showError(errorMessage)
        //             return
        //         }
        //         onClose && onClose()
        //         onSave && onSave()
        //     }
        // })
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    bCanSave = () => {
        const 订餐月份 = getFormValue(this, '基本信息', 订餐月份)
        return 订餐月份 && 订餐月份 != nullDate
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _month: '订餐月份', minWidth: '95%' }
        ]
    }
    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, bReadOnly } = this.state
        if (errorMessage) return <Message text={errorMessage} />
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth='800'
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '确定', icon: 'save', handler: this.handelExportMealOrderRecord, disabled: !bChanged },
                        { _button: '取消', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly, },
                ]}
        />
    }
}

export default connect()(SelectDateDiv)